
    module.exports = require('./Ellipse').Circle;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/geom/Circle.js
// module id = 48
// module chunks = 15